<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-prologue element-with-heading" epub:type="prologue" id="prologue" role="doc-prologue">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">PROLOGUE</h1>
</div>
</div>
</div>
</div>
<div class="text" id="prologue-text">
<p class="first first-in-chapter first-full-width first-with-first-letter-i"><span class="drop-cap">I</span> didn’t want him to be cold, so I tucked his jacket in around him. It was his favourite; one that I’d bought him for Christmas – or his birthday, I forget. I hadn’t noticed when I saw him earlier in the night, that that’s what he was wearing. It was such a happy memory, though, when I did realise, because he’d wanted the jacket for ages. It was stupidly expensive, and I hadn’t even liked it that much when he pointed it out, two months before – so it must have been Christmas when I bought it, because I remember saving money through October and part of November to make sure I could get it. And – and I hadn’t even liked it. Still, I tucked it in around him, because I didn’t want him to be cold. But more than anything, I just didn’t want him to be dead.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?fd6b53ea